/**
 * Tokens de elevación/forma compartidos por las tarjetas del detalle de
 * recorrido. Dan profundidad consistente (estilo "data-dense dashboard") sin
 * tocar el ChartCard global usado por otras pantallas.
 */
export const CARD_SHADOW = '0 1px 2px rgba(16,24,40,0.05), 0 6px 16px rgba(16,24,40,0.06)'
export const CARD_SHADOW_HOVER = '0 10px 30px rgba(16,24,40,0.12)'

/** Verde de ruta legible sobre el mapa claro (el brand.green #012d1d se ve casi negro). */
export const ROUTE_COLOR = '#1A7A4C'
/** Gris tenue para la parte de la ruta fuera del tramo seleccionado. */
export const ROUTE_DIM_COLOR = '#9AA6A0'
